import { type Route } from './+types/index.ts'

export default function ScheduleIndexRoute() {
	return (
		<div className="container pt-12">
			<p className="text-body-md">Select a schedule</p>
		</div>
	)
}

export const meta: Route.MetaFunction = () => {
	return [
		{ title: `Irrigation Schedules | Clearwater Farms 1` },
		{
			name: 'description',
			content: `Clearwater Farms 1 Irrigation Schedules`,
		},
	]
}
